ui-cms-image {
  display: block;

  picture {
    display: block;
    height: 100%;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
